
    import React from 'react';
    import ReactDOM from 'react-dom';
    import Component from '/home/circleci/app/packages/layout-onetrust-component/src/entries/OneTrust';

    const element = typeof document !== 'undefined' && document.querySelector('#LayoutOnetrustComponent-Onetrust-component');

    if (element) {
        const props = window.initialData['LayoutOnetrustComponent-Onetrust'];

        ReactDOM.render(
            <Component {...props}/>,
            element
        );
    }

    export default Component;
    